import { ImageIcon } from "lucide-react";
import { AppImage } from "@/shared/ui/AppImage";

export function QiCatalogCardImage({
  src,
  alt,
  className,
}: {
  src: string | null | undefined;
  alt: string;
  className?: string;
}) {
  return (
    <div
      className={`relative aspect-[4/3] w-full shrink-0 overflow-hidden bg-muted/20 ${className ?? ""}`}
    >
      <AppImage
        src={src}
        alt={alt}
        className="absolute inset-0 size-full"
        fit="cover"
        fallback={
          <div className="flex size-full items-center justify-center bg-muted/30 text-muted-foreground">
            <ImageIcon className="size-10" aria-hidden />
          </div>
        }
      />
    </div>
  );
}

export function QiCatalogCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-xl border bg-card">
      <div className="aspect-[4/3] w-full animate-pulse bg-muted/40" />
      <div className="space-y-2 p-3">
        <div className="h-3 w-16 animate-pulse rounded bg-muted/50" />
        <div className="h-4 w-full animate-pulse rounded bg-muted/50" />
      </div>
    </div>
  );
}
